const USER_POSITIONS = [
  { id: "CO", label: "Credit Officer" },
  { id: "BM", label: "Branch Manager" },
  { id: "AM", label: "Area Manager" },
  { id: "ZM", label: "Zonal Manager" },
  { id: "SM", label: "State Manager" },
  { id: "DR", label: "Director" },
];

export const IS_PROD = window.location.hostname === "opulentpeerless.com";

function generatePassword() {
  let length = 8,
    charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
    retVal = "";
  for (let i = 0, n = charset?.length; i < length; ++i) {
    retVal += charset.charAt(Math.floor(Math.random() * n));
  }
  return retVal;
}

export const getRelatedOrgFieldMeta = (relatedOrType) => {
  switch (relatedOrType) {
    case "branches":
      return {
        idField: "area_id",
        singularName: "Area",
        type: "areas",
      };
    case "areas":
      return {
        idField: "zone_id",
        singularName: "Zone",
        type: "zones",
      };
    case "zones":
      return {
        idField: "state_id",
        singularName: "State",
        type: "states",
      };
  }
};

export const getOrgFieldMeta = (user, relatedOrgType) => {
  switch (relatedOrgType) {
    case "branch":
      return {
        idField: "branch_id",
        singularName: "Branch",
        type: "branches",
        id: user?.branch?.id,
      };
    case "area":
      return {
        idField: "area_id",
        singularName: "Area",
        type: "areas",
        id: user?.area?.id,
      };
    case "zone":
      return {
        idField: "zone_id",
        singularName: "Zone",
        type: "zones",
        id: user?.zone?.id,
      };
    case "state":
      return {
        idField: "state_id",
        singularName: "State",
        type: "states",
        id: user?.state?.id,
      };
    // case "staff":
    //   return {
    //     idField: "state_id",
    //     singularName: "State",
    //     type: "states",
    //     id: user?.state?.id,
    //   };
    default:
      return {
        idField: "",
        singularName: "",
        type: "",
        id: "",
      };
  }
};

export const getOrgDashboardIdField = (type) => {
  // Get id field with org name or position
  switch (type) {
    case "CO":
    case "cos":
      return "co_id";
    case "branches":
    case "branch":
    case "BM":
      return "branch_id";
    case "areas":
    case "area":
    case "AM":
      return "area_id";
    case "zones":
    case "zone":
    case "ZM":
      return "zone_id";
    case "states":
    case "state":
    case "SM":
      return "state_id";
    default:
      return "";
  }
};

export const getOrgStaffProfileOrgField = (type) => {
  // Get id field with org name or position
  switch (type) {
    case "CO":
    case "cos":
      return "branch";
    case "branches":
    case "branch":
    case "BM":
      return "branch";
    case "areas":
    case "area":
    case "AM":
      return "area";
    case "zones":
    case "zone":
    case "ZM":
      return "zone";
    case "states":
    case "state":
    case "SM":
      return "state";
    default:
      return "";
  }
};

export const positionToOrgMapping = {
  CO: "cos",
  BM: "branch",
  AM: "area",
  ZM: "zone",
  SM: "state",
  DR: "",
};

export const positionToOrgMapping2 = {
  CO: "cos",
  BM: "branches",
  AM: "areas",
  ZM: "zones",
  SM: "states",
  DR: "",
};

export const staffCreationPositionMapping = {
  CO: "branches",
  BM: "branches",
  AM: "areas",
  ZM: "zones",
  SM: "states",
  DR: "",
};

export const getPlural = {};

export const messagingPositionMapping = {
  CO: [],
  BM: ["BRANCH", "STAFF"],
  AM: ["AREA", "BRANCH", "STAFF"],
  ZM: ["ZONE", "AREA", "BRANCH", "STAFF"],
  SM: ["STATE", "ZONE", "AREA", "BRANCH", "STAFF"],
  DR: ["STATE", "ZONE", "AREA", "BRANCH", "STAFF"],
};

const permissionLevels = {
  CO: 1,
  BM: 2,
  AM: 3,
  ZM: 4,
  SM: 5,
  DR: 6,
};

export const positionsMapping = {
  CO: "Credit Officer",
  BM: "Branch Manager",
  AM: "Area Manager",
  ZM: "Zonal Manager",
  SM: "State Manager",
  DR: "Director",
};

const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export {
  USER_POSITIONS,
  generatePassword,
  permissionLevels,
  capitalizeFirstLetter,
};

export const getErrorMsg = (message) => ({
  status: "danger",
  message: message || "An error occured, please try again",
});

export const pluraliseOrgLevel = (level) => {
  if (level === "branch") {
    return "branches";
  }
  return `${level}s`;
};

export const hashToken = (token) => {
  if (token) {
    return token.split("").reverse().join("");
  }
};

const getErrorMessageFromRes = async (response) => {
  const data = await response?.json();
  let errorMessage = "";

  if (data?.detail === "Invalid token.") {
    localStorage.removeItem("user_local_token");
    return;
  }

  const errorKeys = Object.keys(data);
  for (let index = 0; index < errorKeys?.length; index++) {
    const field = errorKeys[index];
    errorMessage = errorMessage.concat(`${data[field]} `);
  }
  console.log({ errorMessage });
  throw new Error(errorMessage);
};

export const makeRequest = async (url, method = "GET", data) => {
  const token = localStorage.getItem("user_local_token");
  const TOKEN_UNAVAILABLE =
    token === "undefined" || token === undefined || token === null;

  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
  };

  if (!TOKEN_UNAVAILABLE) {
    headers["Authorization"] = `Token ${hashToken(token)}`;
  }

  const requestOptions = {
    headers,
    method,
    mode: "cors",
  };

  if (data) {
    requestOptions["body"] = JSON.stringify(data);
  }

  const response = await fetch(url, requestOptions);

  // DELETE requests returna a no content response.

  if (!response?.ok) {
    return getErrorMessageFromRes(response);
  }
  if (response.statusText === "No Content") {
    return {};
  }
  return response?.json();
};

const loanStatus = {
  awaiting_disbursment: "AWAITING DISBURSMENT",
  disbursed: "DISBURSED",
  active: "ACTIVE",
  completed: "COMPLETED",
  default: "DEFAULT",
  waived: "WAIVED",
};

export const LOANS_STATUS = Object.values(loanStatus);
export const DAILY_PAY_STATUS = ["INACTIVE", "PAID", "UNPAID", "WAIVED"];

const clientStatus = {
  active: "ACTIVE", // Has collected a loan before
  registered: "REGISTERED",
};

export const getStatusClassName = (status) => {
  switch (status) {
    case loanStatus.awaiting_disbursment:
      return "badge-dark";
    case loanStatus.completed:
      return "badge-success";
    case loanStatus.default:
      return "badge-danger";
    case loanStatus.disbursed:
      return "badge-secondary";
    case loanStatus.active:
      return "badge-primary";
    default:
      return "";
  }
};

export const fallbackImg =
  "data:image/png;base64,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";

export const MESSAGE_RECIPIENT_TYPE = [
  "STATE",
  "ZONE",
  "AREA",
  "BRANCH",
  "STAFF",
];

export const getSingularOrgListName = (name) => {
  switch (name?.toLowerCase()) {
    case "branches":
    case "branch":
      return "Branch";
    case "zones":
    case "zone":
      return "Zone";
    case "areas":
    case "area":
      return "Area";
    case "states":
    case "state":
      return "State";
    default:
      return ""
  }
};

export const getTotal = (data) => {
  const additions =
    Number(data?.special_income || 0) +
    Number(data?.realised_installment || 0) +
    Number(data?.realised_savings || 0) +
    Number(data?.prev_cash_in_hand_paid || 0) +
    Number(data?.total_disbursement_fee || 0) +
    Number(data?.total_reg_fee || 0) +
    Number(data?.total_union_fee || 0) +
    Number(data?.total_admin_fee || 0) +
    Number(data?.sold_assets || 0) +
    Number(data?.retrieved_assets || 0) +
    Number(data?.advanced_payment || 0) +
    Number(data?.total_waiver_fee || 0) +
    Number(data?.total_waiver_balance  || 0) +
    Number(data?.total_additional_savings || 0) +
    Number(data?.total_contribution || 0) +
    Number(data?.total_contribution_fee || 0);
    
  const subtractions =
    Number(data?.expenses || 0) +
    Number(data?.total_cash_withdrawal || 0) +
    Number(data?.total_withdrawal_for_dailypay || 0);

  return additions - subtractions;
};

export const getCashInHand = (data) => {
  // if (!data) {
  //   return 0;
  // }

  // const additions =
  //   Number(data?.realizable_installment) + Number(data?.realizable_savings);

  // const subtractions =
  //   Number(data?.realised_installment) +
  //   Number(data?.realised_savings) +
  //   Number(data?.waived_installment) +
  //   Number(data?.waived_savings);

  // return Number(additions) - Number(subtractions)
  return Number(data?.cash_in_hand);
};

export const getSummationOfFields = ({
  data = [],
  fieldsToSum = [],
  fieldWithHandlers = {},
}) => {
  const summedFields = {};
  for (let index = 0; index < data.length; index++) {
    const isLastRound = index + 1 === data.length;
    const dataInstance = data[index];

    // Loop through all the fieldsToSum and increaments the summedFields fields with it.
    fieldsToSum?.forEach((field) => {
      if (fieldWithHandlers[field]) {
        summedFields[field] =
          (summedFields[field] || 0) +
          Number(fieldWithHandlers[field](dataInstance) || 0);
        if (isLastRound) {
          summedFields[field] = Number(summedFields[field]).toLocaleString();
        }
        return;
      }
      summedFields[field] =
        (summedFields[field] || 0) + Number(dataInstance[field]);

      if (isLastRound) {
        summedFields[field] = Number(summedFields[field]).toLocaleString();
      }
    });
  }

  return summedFields;
};

export const getDashboardUrlWithParam = ({
  isOrgDashboard,
  path,
  orgType,
  id,
  orgName,
  userOrgField,
  user,
  prefixPath = "org",
}) => {
  if (isOrgDashboard) {
    return `/${prefixPath}/${orgType}/${id}/${path}?org=${orgType}&name=${orgName}`;
  }
  return `/${path}?org=${orgType || userOrgField}&name=${
    user[userOrgField]?.name || ""
  }`;
};


/**
* Updates the old urls to the new aws bucket we are now using
*/
export const cleanedImage = (url) => {
  if (!url) return ""
  if (url.includes('opulentsytemimages3')) {
    return url
  }
  const oldBucketName = "opulentsytemimages2"
  const newBucketName = "opulentsytemimages3"
  
  return url?.replace(oldBucketName, newBucketName)
}